import { render, staticRenderFns } from "./ModelsCatalogCustomer.vue?vue&type=template&id=584ae544&scoped=true&"
import script from "./ModelsCatalogCustomer.vue?vue&type=script&lang=js&"
export * from "./ModelsCatalogCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModelsCatalogCustomer.vue?vue&type=style&index=0&id=584ae544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ae544",
  null
  
)

export default component.exports